import React, {Component} from 'react';
import {CheckMimeType} from "../helpers/checkMimeType";
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {ComparisonSourceTypes, InputTypes} from "../reducers/store";
import {updateSource, setSelectedOnly} from "../reducers/files";

class CompareFile extends Component {
  constructor (props) {
    super(props);
    this.state = {
      errors: {}
    }
  }
  
  onInputFileChange = e => {
    const {updateSource, sourceType} = this.props;
    const file = e.target.files[0];
    console.log(file);
    if (CheckMimeType(e)) {
       this.setState({
        errors: {
         ...this.state.errors,
           mimeType: null
        }
      }, () => {
        updateSource({
          inputType: InputTypes.FILE,
          sourceType,
          file
        });
       });
     } else {
      alert( "Plik "+file.name+"niepomyślnie załadowany błędny format");
       this.setState({
        errors: {
           ...this.state.errors,
           mimeType: 'Ten format pliku nie jest obsługiwany'
        }
      });
     }
  }
  
  
  /* pozostalos po funkcji text
  onInputTypeChange = e => {
    const {updateSource, sourceType} = this.props;
    updateSource({
      inputType: e.target.value,
      sourceType
    });
  }*/
  
  setSelectedOnly = () => {
    const {selectedOnly} = this.props;
    console.log("zmiana");   
     this.props.setSelectedOnly(!selectedOnly);
  }
  
  render () {
    const {sourceType, label, source, processing, inProgress, selectedOnly, secondLabel,textorfile} = this.props;
    const {inputType,  filename, isJSAReport} = source;
    /*usuniety warunek disable 
    ||(((textorfile === null)||(textorfile === "TEXT"))&&(secondLabel === "true"))
    disabled={(((textorfile === null)||(textorfile === "TEXT"))&&(secondLabel === "true"))}
    
    `input-document-box ${inputType === InputTypes.FILE ? 'checked' : ''}`
    */


    return <div >
      
  
     
      <div className={`jsa-frame-drop${((inputType === InputTypes.FILE)&&!(((textorfile === null)||(textorfile === "TEXT"))&&(secondLabel === "true")))? 'checked' : ''}`}>

    
  
        <div className="jsa-demo-drop">
          <input type="file"
                 data-content={filename}
                 title={filename}
                 onChange={this.onInputFileChange}
                 onClick={e => {e.currentTarget.value = null}}
                 disabled={processing || inProgress}
                 className="form-control"/>
                 <button style={{borderRadius: 5}} 
                         className={` wp-block-button__link has-white-color has-text-color has-background select-file-button ${(((textorfile === null)||(textorfile === "TEXT"))&&(secondLabel === "true"))? "jsa-drop-button-disable":""}`} >Wybierz plik</button>
          <div className="drop-file-name">{((inputType === InputTypes.FILE)&&!(((textorfile === null)||(textorfile === "TEXT"))&&(secondLabel === "true"))) ? [filename] :['']}</div>
        </div>
        {sourceType === ComparisonSourceTypes.ORIGINAL && inputType === InputTypes.FILE && isJSAReport  &&<label className="selected-only">
          <input type="checkbox" checked={selectedOnly} disabled={processing || inProgress} onChange={this.setSelectedOnly}/>
          Porównaj tylko zaznaczone fragmenty raportu JSA 
        </label>}
      </div>
      <div className="allowed-file-types">dopuszczalne rozszerzenia plików: pdf, doc, docx</div>
    </div>;
  }
}

CompareFile.propTypes = {
  sourceType: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  secondLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  source: PropTypes.object,
  updateSource: PropTypes.func,
  processing: PropTypes.bool,
  setSelectedOnly: PropTypes.func,
  selectedOnly: PropTypes.bool,
  inProgress: PropTypes.bool
}

CompareFile.defaultProps = {
  sourceType: ComparisonSourceTypes.ORIGINAL,
  label: '',
  secondLabel: '',
  updateSource: () => {},
  setSelectedOnly: () => {},
  selectedOnly: false,
  processing: false
}

export default connect(
  ({originalSource, userSource, processing, inProgress, selectedOnly}, {sourceType = ComparisonSourceTypes.ORIGINAL}) => ({
    selectedOnly,
    inProgress,
    source: sourceType === ComparisonSourceTypes.ORIGINAL ? originalSource : userSource,
    processing
  }),
  {updateSource, setSelectedOnly}
)(CompareFile);